import { Injectable } from '@angular/core';
import { SseClient } from 'ngx-sse-client';
import { HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class SseService {

  constructor(protected sseClient: SseClient) { }

  /**
   * Stream SSE events from a given URL with optional headers.
   * @param url The URL to subscribe to.
   * @param headers Optional headers to include in the request.
   * @param requestMethod The method for the request (default GET).
   * @param options Additional SSE options like keep-alive, reconnection delay, etc.
   * @returns Observable for SSE events.
   */
  streamSse(
    url: string,
    headers: HttpHeaders = new HttpHeaders(),
    requestMethod: 'POST' | 'GET' = 'GET',
    options: { keepAlive?: boolean; reconnectionDelay?: number } = {}
  ): Observable<any> {
    const defaultOptions = {
      keepAlive: true,
      reconnectionDelay: 1_000,
      responseType: 'event' as const,
      ...options
    };

    return this.sseClient.stream(
      url,
      defaultOptions,
      { headers },
      requestMethod
    );
  }
}
